import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import React from 'react';
import reactStringReplace from 'react-string-replace';

import { patientPropType } from 'Shared/types';
import ScrollToElementLink from '../ScrollToElementLink';
import { scorePropType } from '../types';
import AssessmentContentMonographLink from './AssessmentContentMonographLink';

const END_OF_LINE_CONTENT_ID = 'end-of-line-content-marker';

const DisplayCMSContent = ({ content, patient, score, endOfLineContent, suppressMonographLink }) => {
    const withEndOfLineContentMarker = content.replace(
        /(<br\s*\/?>|<\/p>|<ul|$)/,
        ` <span id="${END_OF_LINE_CONTENT_ID}"></span>$1`
    );
    const parsed = parse(withEndOfLineContentMarker, {
        transform: (reactNode, domNode, index) => {
            if (domNode.type === 'text') {
                const replacedString = reactStringReplace(reactNode, /\{\{([^{}]*?)\}\}/g, (match, i) => {
                    return (
                        <AssessmentContentMonographLink
                            key={match + i}
                            templateMatch={match}
                            patient={patient}
                            suppressLink={suppressMonographLink}
                        />
                    );
                });
                return replacedString;
            }

            if (domNode.name === 'a' && domNode.attribs.href === '#pend-activity-btn') {
                return (
                    <ScrollToElementLink key={index} elementId={domNode.attribs.href.replace(/^#/, '')}>
                        {reactNode.props.children}
                    </ScrollToElementLink>
                );
            }

            if (domNode.name === 'span' && ['rapid3-score', 'rapid3-functional-score'].includes(domNode.attribs.id)) {
                return (
                    <domNode.name {...domNode.attribs} key={index}>
                        {score.value}
                    </domNode.name>
                );
            }
            if (domNode.name === 'span' && domNode.attribs.id === 'rapid3-stratification') {
                return (
                    <domNode.name {...domNode.attribs} key={index}>
                        {score.stratification}
                    </domNode.name>
                );
            }

            if (domNode.name === 'span' && domNode.attribs.id === END_OF_LINE_CONTENT_ID) {
                return endOfLineContent;
            }

            return reactNode;
        },
    });

    return parsed;
};

DisplayCMSContent.propTypes = {
    content: PropTypes.string.isRequired,
    patient: patientPropType,
    score: scorePropType,
    endOfLineContent: PropTypes.node,
    suppressMonographLink: PropTypes.bool,
};

DisplayCMSContent.defaultProps = {
    patient: null,
    score: null,
    endOfLineContent: null,
    suppressMonographLink: false,
};

export default DisplayCMSContent;
